module.exports = __webpack_public_path__ + "static/img/noData.65a609dc.png";